import { useContext, useState } from 'react';
import './Dashboard.css';
import { GlobalContext } from '../../utils/globalContext';
import dayjs from 'dayjs';
import Clock from '../common/Clock';
import { Alert, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
const Dashboard = () => {
  const navigate = useNavigate();
  const context = useContext(GlobalContext);
  const [backgroundImage] = useState('https://picsum.photos/1920/1080');

  dayjs.locale('es');
  const formattedDate = dayjs().format('dddd D MMMM [del] YYYY');

  const { user } = context;

  return (
    <div
      className="dashboard-content-inner"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        height: 'calc(100vh - 106px)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
      <Clock />
      <h1>Bienvenido</h1>

      <p className="welcome-user-name">
        {user.isAdmin
          ? `${user?.user_nombre_str} ${user?.user_apellido1_str}`
          : `${user.clie_nombre} ${user.clie_ap || ''} ${user.clie_am || ''}`}
      </p>

      <p className="welcome-user-email">{user.clie_correo || ''}</p>

      <p className="welcome-date-text">{formattedDate}</p>

      {user.clie_tipo === 0 && (
        <Alert
          message="Atención!!"
          description="Actualiza tus datos fiscales para poder emitir tus facturas"
          type="warning"
          showIcon
          closable
          action={
            <Button size="small" type="primary" onClick={() => navigate('/profile')}>
              Ir a mi perfil
            </Button>
          }
        />
      )}
    </div>
  );
};

export default Dashboard;
